
export default {
  name: 'StrikeTextGenerator',
  data () {
    return {
      data: '',
      form: this.$vform({
        text: 'Hello'
      })
    }
  },
  methods: {
    onStrikeThrough() {
        // Unicode character for strike-through
        const strikeThroughChar = '\u0336';
        
        // Apply strike-through to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + strikeThroughChar;
        }).join('');
    },
    onUnderline() {
        // Unicode character for double underline
        const doubleUnderlineChar = '\u035F';
        
        // Apply double underline to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + doubleUnderlineChar;
        }).join('');
    },
    onDoubleUnderline() {
        // Unicode character for underline
        const underlineChar = '\u0333';
        
        // Apply underline to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + underlineChar;
        }).join('');
    },
    onItalics() {
        const italicsChars = {
            'A': '\u{1D434}', 'B': '\u{1D435}', 'C': '\u{1D436}', 'D': '\u{1D437}', 
            'E': '\u{1D438}', 'F': '\u{1D439}', 'G': '\u{1D43A}', 'H': '\u{1D43B}',
            'I': '\u{1D43C}', 'J': '\u{1D43D}', 'K': '\u{1D43E}', 'L': '\u{1D43F}',
            'M': '\u{1D440}', 'N': '\u{1D441}', 'O': '\u{1D442}', 'P': '\u{1D443}',
            'Q': '\u{1D444}', 'R': '\u{1D445}', 'S': '\u{1D446}', 'T': '\u{1D447}',
            'U': '\u{1D448}', 'V': '\u{1D449}', 'W': '\u{1D44A}', 'X': '\u{1D44B}',
            'Y': '\u{1D44C}', 'Z': '\u{1D44D}',
            'a': '\u{1D44E}', 'b': '\u{1D44F}', 'c': '\u{1D450}', 'd': '\u{1D451}', 
            'e': '\u{1D452}', 'f': '\u{1D453}', 'g': '\u{1D454}', 'h': '\u{210E}', 
            'i': '\u{1D456}', 'j': '\u{1D457}', 'k': '\u{1D458}', 'l': '\u{1D459}', 
            'm': '\u{1D45A}', 'n': '\u{1D45B}', 'o': '\u{1D45C}', 'p': '\u{1D45D}', 
            'q': '\u{1D45E}', 'r': '\u{1D45F}', 's': '\u{1D460}', 't': '\u{1D461}', 
            'u': '\u{1D462}', 'v': '\u{1D463}', 'w': '\u{1D464}', 'x': '\u{1D465}', 
            'y': '\u{1D466}', 'z': '\u{1D467}'
        };

        this.data = this.form.text.split('').map(char => {
            return italicsChars[char] || char;
        }).join('');
    },
    onBold() {
        const boldChars = {
            'A': '\u{1D400}', 'B': '\u{1D401}', 'C': '\u{1D402}', 'D': '\u{1D403}',
            'E': '\u{1D404}', 'F': '\u{1D405}', 'G': '\u{1D406}', 'H': '\u{1D407}',
            'I': '\u{1D408}', 'J': '\u{1D409}', 'K': '\u{1D40A}', 'L': '\u{1D40B}',
            'M': '\u{1D40C}', 'N': '\u{1D40D}', 'O': '\u{1D40E}', 'P': '\u{1D40F}',
            'Q': '\u{1D410}', 'R': '\u{1D411}', 'S': '\u{1D412}', 'T': '\u{1D413}',
            'U': '\u{1D414}', 'V': '\u{1D415}', 'W': '\u{1D416}', 'X': '\u{1D417}',
            'Y': '\u{1D418}', 'Z': '\u{1D419}',
            'a': '\u{1D41A}', 'b': '\u{1D41B}', 'c': '\u{1D41C}', 'd': '\u{1D41D}',
            'e': '\u{1D41E}', 'f': '\u{1D41F}', 'g': '\u{1D420}', 'h': '\u{1D421}',
            'i': '\u{1D422}', 'j': '\u{1D423}', 'k': '\u{1D424}', 'l': '\u{1D425}',
            'm': '\u{1D426}', 'n': '\u{1D427}', 'o': '\u{1D428}', 'p': '\u{1D429}',
            'q': '\u{1D42A}', 'r': '\u{1D42B}', 's': '\u{1D42C}', 't': '\u{1D42D}',
            'u': '\u{1D42E}', 'v': '\u{1D42F}', 'w': '\u{1D430}', 'x': '\u{1D431}',
            'y': '\u{1D432}', 'z': '\u{1D433}'
        };

        this.data = this.form.text.split('').map(char => {
            return boldChars[char] || char;
        }).join('');
    },
    onCursive() {
        const cursiveChars = {
            'A': '\u{1D4D0}', 'B': '\u{1D4D1}', 'C': '\u{1D4D2}', 'D': '\u{1D4D3}',
            'E': '\u{1D4D4}', 'F': '\u{1D4D5}', 'G': '\u{1D4D6}', 'H': '\u{1D4D7}',
            'I': '\u{1D4D8}', 'J': '\u{1D4D9}', 'K': '\u{1D4DA}', 'L': '\u{1D4DB}',
            'M': '\u{1D4DC}', 'N': '\u{1D4DD}', 'O': '\u{1D4DE}', 'P': '\u{1D4DF}',
            'Q': '\u{1D4E0}', 'R': '\u{1D4E1}', 'S': '\u{1D4E2}', 'T': '\u{1D4E3}',
            'U': '\u{1D4E4}', 'V': '\u{1D4E5}', 'W': '\u{1D4E6}', 'X': '\u{1D4E7}',
            'Y': '\u{1D4E8}', 'Z': '\u{1D4E9}',
            'a': '\u{1D4EA}', 'b': '\u{1D4EB}', 'c': '\u{1D4EC}', 'd': '\u{1D4ED}',
            'e': '\u{1D4EE}', 'f': '\u{1D4EF}', 'g': '\u{1D4F0}', 'h': '\u{1D4F1}',
            'i': '\u{1D4F2}', 'j': '\u{1D4F3}', 'k': '\u{1D4F4}', 'l': '\u{1D4F5}',
            'm': '\u{1D4F6}', 'n': '\u{1D4F7}', 'o': '\u{1D4F8}', 'p': '\u{1D4F9}',
            'q': '\u{1D4FA}', 'r': '\u{1D4FB}', 's': '\u{1D4FC}', 't': '\u{1D4FD}',
            'u': '\u{1D4FE}', 'v': '\u{1D4FF}', 'w': '\u{1D500}', 'x': '\u{1D501}',
            'y': '\u{1D502}', 'z': '\u{1D503}'
        };

        this.data = this.form.text.split('').map(char => {
            return cursiveChars[char] || char;
        }).join('');
    },
    onSlashSymbol() {
        // Unicode character for slash overlay
        const slashChar = '\u0337';
        
        // Apply slash overlay to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + slashChar;
        }).join('');
    },
    onDottedLine() {
        // Unicode character for dotted line
        const dottedLineChar = '\u0324';
        
        // Apply dotted line to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + dottedLineChar;
        }).join('');
    },
    onWaveLine() {
        // Unicode character for wave line
        const waveLineChar = '\u0330';
        
        // Apply wave line to each character
        this.data = this.form.text.split('').map(char => {
            // Don't apply to spaces to keep text readable
            return char === ' ' ? char : char + waveLineChar;
        }).join('');
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
